var map = {
	"./ahla.avif": 8334,
	"./amsraf.avif": 8172,
	"./anantara.avif": 7574,
	"./bm.avif": 9933,
	"./hras.avif": 3918,
	"./inb.avif": 791,
	"./naffco.avif": 5563,
	"./nbq.avif": 4587,
	"./png/ahla.png": 8594,
	"./png/amsraf.png": 3416,
	"./png/anantara.png": 5386,
	"./png/bm.png": 4499,
	"./png/hras.png": 2850,
	"./png/inb.png": 7175,
	"./png/naffco.png": 7009,
	"./png/nbq.png": 5259,
	"./png/scp.png": 2352,
	"./png/smbc.png": 2141,
	"./scp.avif": 6578,
	"./smbc.avif": 3987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6770;